const LOGO_SRC = `${process.env.PUBLIC_URL}/square-one-estates-logo.png`;

export default function BrandLogo({ size = "md", className = "", alt = "Square One Estates" }) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      className={`brand-logo brand-logo--${size}${className ? ` ${className}` : ""}`}
    />
  );
}

export const BRAND_NAME = "Square One Estates";
export const BRAND_TAGLINE = "Elevate. Experience. Belong.";
